import { equals2 } from "fxjs/es";
import { ArtBoardNS } from "../../../../../../ArtBoard/ArtBoardNS.js";
import { BackgroundNS } from "../../../../../../Background/BackgroundNS.js";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { GroupingNS } from "../../../../../../Grouping/GroupingNS.js";
import { LockingNS } from "../../../../../../Locking/LockingNS.js";
import { RubberBandNS } from "../../../../../../RubberBand/RubberBandNS.js";
import { SelectionNS } from "../../../../../../Selection/SelectionNS.js";
import { SelectorNS } from "../../../../../../Selector/SelectorNS.js";
import { StrokeNS } from "../../../../../../Stroke/StrokeNS.js";
import { TransformNS } from "../../../../../../Transform/TransformNS.js";
import { ViewBoxNS } from "../../../../../../ViewBox/ViewBoxNS.js";
import { ViewPortNS } from "../../../../../../ViewPort/ViewPortNS.js";
import { WorkingLayerNS } from "../../../../../../WorkingLayer/WorkingLayerNS.js";
export const initEditor = (self) => {
  const canvas_el = self._getCanvasElThrowable();
  const dummy_g_el = self._getDummyGElThrowable();
  const layers_el = self._getLayersElThrowable();
  const working_layer_el = self._getWorkingLayerElThrowable();
  const art_board_rect_el = self._getArtBoardRectElThrowable();
  const art_board_filter_drop_shadow_el =
    self._getArtBoardFilterDropShadowElThrowable();
  const art_board_clip_path_rect_el =
    self._getArtBoardClipPathRectElThrowable();
  const background_base_el = self._getBackgroundBaseElThrowable();
  const background_color_el = self._getBackgroundColorElThrowable();
  const background_image_el = self._getBackgroundImageElThrowable();
  const selector_path_el = self._getSelectorPathElThrowable();
  const selector_nw_circle_el = self._getSelectorNWCircleElThrowable();
  const selector_n_circle_el = self._getSelectorNCircleElThrowable();
  const selector_ne_circle_el = self._getSelectorNECircleElThrowable();
  const selector_e_circle_el = self._getSelectorECircleElThrowable();
  const selector_se_circle_el = self._getSelectorSECircleElThrowable();
  const selector_s_circle_el = self._getSelectorSCircleElThrowable();
  const selector_sw_circle_el = self._getSelectorSWCircleElThrowable();
  const selector_w_circle_el = self._getSelectorWCircleElThrowable();
  const selector_r_circle_el = self._getSelectorRCircleElThrowable();
  const rubber_band_el = self._getRubberBandElThrowable();
  const view_port = new ViewPortNS.ModelNS.ViewPort({
    width: 0,
    height: 0,
  });
  self._view_port = view_port;
  const view_port_controller = new ViewPortNS.ControllerNS.ViewPortController({
    view_port,
  });
  new ViewPortNS.ViewNS.ViewPortElView({
    view_port_el: canvas_el,
    view_port_controller,
  });
  new ViewPortNS.ViewNS.ViewPortElView({
    view_port_el: layers_el,
    view_port_controller,
  });
  const view_box = new ViewBoxNS.ModelNS.ViewBox({
    svg_el: self._svg_el,
    min_s: 0.4,
    max_s: 2,
  });
  self._view_box = view_box;
  const view_box_controller = new ViewBoxNS.ControllerNS.ViewBoxController({
    view_box,
  });
  new ViewBoxNS.ViewNS.ViewBoxElView({
    view_box_el: layers_el,
    view_box_controller,
  });
  const working_layer =
    new WorkingLayerNS.ModelNS.SingleStickerEditorWorkingLayer({
      layer_el: working_layer_el,
      Node,
      SVGGraphicsElement: self._window.SVGGraphicsElement,
    });
  self._working_layer = working_layer;
  const art_board = new ArtBoardNS.ModelNS.ArtBoard({
    width: 0,
    height: 0,
    svg_el: self._svg_el,
    getCTM: () => {
      const ctm = art_board_rect_el.getCTM();
      if (ctm == null) {
        throw new Error(`아트보드 엘리먼트의 CTM 을 구할 수 없습니다.`);
      }
      return ctm;
    },
  });
  self._art_board = art_board;
  const art_board_controller = new ArtBoardNS.ControllerNS.ArtBoardController({
    art_board,
  });
  new ArtBoardNS.ViewNS.ArtBoardView({
    art_board_controller,
    art_board_rect_el,
    art_board_filter_drop_shadow_el,
  });
  new ArtBoardNS.ViewNS.ArtBoardClipPathRectView({
    art_board_controller,
    art_board_clip_path_rect_el,
  });
  const background = new BackgroundNS.ModelNS.Background({
    value: new BackgroundNS.ModelNS.BackgroundColorValue({
      fill: "#FFFFFF",
      opacity: 1,
    }),
    art_board,
  });
  self._background = background;
  const background_controller =
    new BackgroundNS.ControllerNS.BackgroundController({
      background,
    });
  new BackgroundNS.ViewNS.BackgroundView({
    background_base_el,
    background_color_el,
    background_image_el,
    background_controller,
  });
  const locking = new LockingNS.ModelNS.Locking();
  self._locking = locking;
  const selection = new SelectionNS.ModelNS.SingleStickerEditorSelection({
    SVGGraphicsElement: self._window.SVGGraphicsElement,
    working_layer,
    working_layer_el,
    svg_el: self._svg_el,
    locking,
  });
  self._selection = selection;
  const rubber_band = new RubberBandNS.ModelNS.RubberBand();
  rubber_band.subscribe(({ status, point1, point2 }) => {
    if (!equals2(status)("END")) {
      return;
    }
    selection.selectIn({
      point1,
      point2,
    });
  });
  self._rubber_band = rubber_band;
  const rubber_band_controller =
    new RubberBandNS.ControllerNS.RubberBandController({
      rubber_band,
    });
  new RubberBandNS.ViewNS.RubberBandView({
    rubber_band_el,
    rubber_band_controller,
  });
  const translate_transform = new TransformNS.ModelNS.TranslateTransform({
    svg_el: self._svg_el,
    transform_manipulator: self._transform_manipulator,
  });
  self._translate_transform = translate_transform;
  const scale_transform = new TransformNS.ModelNS.ScaleTransform({
    svg_el: self._svg_el,
    transform_manipulator: self._transform_manipulator,
  });
  self._scale_transform = scale_transform;
  const selection_translate_transform =
    new TransformNS.ModelNS.TranslateTransforming({
      svg_el: self._svg_el,
      transform_manipulator: self._transform_manipulator,
    });
  self._selection_translate_transform = selection_translate_transform;
  const selection_scale_transform1 = new TransformNS.ModelNS.ScaleTransforming1(
    {
      svg_el: self._svg_el,
      transform_manipulator: self._transform_manipulator,
      scale_transform,
    }
  );
  self._selection_scale_transform1 = selection_scale_transform1;
  const selection_scale_transform2 = new TransformNS.ModelNS.ScaleTransforming2(
    {
      svg_el: self._svg_el,
      transform_manipulator: self._transform_manipulator,
      scale_transform,
    }
  );
  self._selection_scale_transform2 = selection_scale_transform2;
  const selection_rotate_transform = new TransformNS.ModelNS.RotateTransforming(
    {
      svg_el: self._svg_el,
      transform_manipulator: self._transform_manipulator,
    }
  );
  self._selection_rotate_transform = selection_rotate_transform;
  const selector_controller =
    new SelectorNS.ControllerNS.SingleStickerEditorSelectorController({
      svg_el: self._svg_el,
      transform_manipulator: self._transform_manipulator,
      getCTM: () => {
        const ctm = dummy_g_el.getCTM();
        if (ctm == null) {
          throw new Error(`selector 엘리먼트의 CTM 을 구할 수 없습니다.`);
        }
        return ctm;
      },
      all_scalable_node_name_set: self._all_scalable_node_name_set,
    });
  selection.subscribe((els) => {
    selector_controller.syncWith(els);
  });
  const selector_controller_observer1 = ({ el }) => {
    const selected_els = selection.getSelectedEls();
    if (selected_els.has(el)) {
      selector_controller.syncWith(selected_els);
    }
  };
  translate_transform.subscribe(selector_controller_observer1);
  scale_transform.subscribe(selector_controller_observer1);
  const selector_controller_observer2 = ({ status, matrix }) => {
    if (equals2(status)("START") || equals2(status)("END")) {
      selector_controller.syncWith(selection.getSelectedEls());
      return;
    }
    selector_controller.transform(matrix);
  };
  selection_translate_transform.subscribe(selector_controller_observer2);
  selection_scale_transform1.subscribe(selector_controller_observer2);
  selection_scale_transform2.subscribe(selector_controller_observer2);
  const selector_controller_observer3 = ({ status, matrix }) => {
    selector_controller.setMode(equals2(status)("END") ? "DEFAULT" : "ROTATE");
    if (equals2(status)("START") || equals2(status)("END")) {
      selector_controller.syncWith(selection.getSelectedEls());
      return;
    }
    selector_controller.transform(matrix);
  };
  selection_rotate_transform.subscribe(selector_controller_observer3);
  self._selector_controller = selector_controller;
  const selector_path_view = new SelectorNS.ViewNS.SelectorPathView({
    selector_path_el,
  });
  selector_controller.subscribe((vo) =>
    selector_path_view.observeSelectorController(vo)
  );
  const selector_circle_view = new SelectorNS.ViewNS.SelectorCircleView({
    r_circle_d: 24,
    transparent_d: 120,
    selector_n_circle_el,
    selector_ne_circle_el,
    selector_e_circle_el,
    selector_se_circle_el,
    selector_s_circle_el,
    selector_sw_circle_el,
    selector_w_circle_el,
    selector_nw_circle_el,
    selector_r_circle_el,
  });
  selector_controller.subscribe((vo) =>
    selector_circle_view.observeSelectorController(vo)
  );
  self._grouping = new GroupingNS.ModelNS.Grouping({
    svg_el: self._svg_el,
    SVGElement: self._window.SVGElement,
    SVGGraphicsElement: self._window.SVGGraphicsElement,
    parent_el: working_layer_el,
    createSVGGElement: () =>
      self._document.createElementNS(CommonNS.ConstNS.SVG_NAMESPACE, "g"),
    transform_manipulator: self._transform_manipulator,
    selection,
    scale_transform,
  });
  const stroke = new StrokeNS.ModelNS.Stroke({
    svg_el: self._svg_el,
    getCTM: () => {
      const ctm = working_layer_el.getCTM();
      if (ctm == null) {
        throw new Error(`working_layer_el 의 CTM 을 구할 수 없습니다.`);
      }
      return ctm;
    },
  });
  self._stroke = stroke;
  const stroke_sync = new StrokeNS.ModelNS.StrokeSync({
    el: working_layer_el,
    SVGGraphicsElement: self._window.SVGGraphicsElement,
    stroke,
  });
  self._stroke_sync = stroke_sync;
  view_box.subscribe(() => stroke_sync.sync());
  view_port.subscribe(() => stroke_sync.sync());
  const touchStartOnCanvasElHandler = (event) =>
    self._handleTouchStartOnCanvasEl(event);
  const touchStartOnSelectorPathElHandler = (event) =>
    self._handleTouchStartOnSelectorPathEl(event);
  const touchStartOnSelectorScaleNCircleElHandler = (event) =>
    self._handleTouchStartOnSelectorScaleCircleEl({
      event,
      origin_circle_el: selector_s_circle_el,
      x_axis_circle_el: selector_se_circle_el,
      y_axis_circle_el: selector_n_circle_el,
      scale_type: TransformNS.ModelNS.SCALE_TYPE.Y,
    });
  const touchStartOnSelectorScaleNECircleElHandler = (event) =>
    self._handleTouchStartOnSelectorScaleCircleEl({
      event,
      origin_circle_el: selector_sw_circle_el,
      x_axis_circle_el: selector_se_circle_el,
      y_axis_circle_el: selector_nw_circle_el,
      scale_type: TransformNS.ModelNS.SCALE_TYPE.XY,
    });
  const touchStartOnSelectorScaleECircleElHandler = (event) =>
    self._handleTouchStartOnSelectorScaleCircleEl({
      event,
      origin_circle_el: selector_w_circle_el,
      x_axis_circle_el: selector_e_circle_el,
      y_axis_circle_el: selector_sw_circle_el,
      scale_type: TransformNS.ModelNS.SCALE_TYPE.X,
    });
  const touchStartOnSelectorScaleSECircleElHandler = (event) =>
    self._handleTouchStartOnSelectorScaleCircleEl({
      event,
      origin_circle_el: selector_nw_circle_el,
      x_axis_circle_el: selector_ne_circle_el,
      y_axis_circle_el: selector_sw_circle_el,
      scale_type: TransformNS.ModelNS.SCALE_TYPE.XY,
    });
  const touchStartOnSelectorScaleSCircleElHandler = (event) =>
    self._handleTouchStartOnSelectorScaleCircleEl({
      event,
      origin_circle_el: selector_n_circle_el,
      x_axis_circle_el: selector_ne_circle_el,
      y_axis_circle_el: selector_s_circle_el,
      scale_type: TransformNS.ModelNS.SCALE_TYPE.Y,
    });
  const touchStartOnSelectorScaleSWCircleElHandler = (event) =>
    self._handleTouchStartOnSelectorScaleCircleEl({
      event,
      origin_circle_el: selector_ne_circle_el,
      x_axis_circle_el: selector_nw_circle_el,
      y_axis_circle_el: selector_se_circle_el,
      scale_type: TransformNS.ModelNS.SCALE_TYPE.XY,
    });
  const touchStartOnSelectorScaleWCircleElHandler = (event) =>
    self._handleTouchStartOnSelectorScaleCircleEl({
      event,
      origin_circle_el: selector_e_circle_el,
      x_axis_circle_el: selector_w_circle_el,
      y_axis_circle_el: selector_se_circle_el,
      scale_type: TransformNS.ModelNS.SCALE_TYPE.X,
    });
  const touchStartOnSelectorScaleNWCircleElHandler = (event) =>
    self._handleTouchStartOnSelectorScaleCircleEl({
      event,
      origin_circle_el: selector_se_circle_el,
      x_axis_circle_el: selector_sw_circle_el,
      y_axis_circle_el: selector_ne_circle_el,
      scale_type: TransformNS.ModelNS.SCALE_TYPE.XY,
    });
  const touchStartOnSelectorRotateCircleElHandler = (event) =>
    self._handleTouchStartOnSelectorRotateCircleEl(event);
  const touchMoveHandler = (event) => self._handleTouchMove(event);
  const touchEndOrCancelHandler = (event) =>
    self._handleTouchEndOrCancel(event);
  self._touchStartOnCanvasElHandler = touchStartOnCanvasElHandler;
  self._touchStartOnSelectorPathElHandler = touchStartOnSelectorPathElHandler;
  self._touchStartOnSelectorScaleNCircleElHandler =
    touchStartOnSelectorScaleNCircleElHandler;
  self._touchStartOnSelectorScaleNECircleElHandler =
    touchStartOnSelectorScaleNECircleElHandler;
  self._touchStartOnSelectorScaleECircleElHandler =
    touchStartOnSelectorScaleECircleElHandler;
  self._touchStartOnSelectorScaleSECircleElHandler =
    touchStartOnSelectorScaleSECircleElHandler;
  self._touchStartOnSelectorScaleSCircleElHandler =
    touchStartOnSelectorScaleSCircleElHandler;
  self._touchStartOnSelectorScaleSWCircleElHandler =
    touchStartOnSelectorScaleSWCircleElHandler;
  self._touchStartOnSelectorScaleWCircleElHandler =
    touchStartOnSelectorScaleWCircleElHandler;
  self._touchStartOnSelectorScaleNWCircleElHandler =
    touchStartOnSelectorScaleNWCircleElHandler;
  self._touchStartOnSelectorRotateCircleElHandler =
    touchStartOnSelectorRotateCircleElHandler;
  self._touchMoveHandler = touchMoveHandler;
  self._touchEndOrCancelHandler = touchEndOrCancelHandler;
  canvas_el.addEventListener("touchstart", touchStartOnCanvasElHandler, {
    passive: false,
  });
  self._window.addEventListener("touchmove", touchMoveHandler, {
    passive: false,
  });
  self._window.addEventListener("touchend", touchEndOrCancelHandler, {
    passive: false,
  });
  self._window.addEventListener("touchcancel", touchEndOrCancelHandler, {
    passive: false,
  });
  selector_path_el.addEventListener(
    "touchstart",
    touchStartOnSelectorPathElHandler,
    {
      passive: false,
    }
  );
  selector_n_circle_el.addEventListener(
    "touchstart",
    touchStartOnSelectorScaleNCircleElHandler,
    {
      passive: false,
    }
  );
  selector_ne_circle_el.addEventListener(
    "touchstart",
    touchStartOnSelectorScaleNECircleElHandler,
    {
      passive: false,
    }
  );
  selector_e_circle_el.addEventListener(
    "touchstart",
    touchStartOnSelectorScaleECircleElHandler,
    {
      passive: false,
    }
  );
  selector_se_circle_el.addEventListener(
    "touchstart",
    touchStartOnSelectorScaleSECircleElHandler,
    {
      passive: false,
    }
  );
  selector_s_circle_el.addEventListener(
    "touchstart",
    touchStartOnSelectorScaleSCircleElHandler,
    {
      passive: false,
    }
  );
  selector_sw_circle_el.addEventListener(
    "touchstart",
    touchStartOnSelectorScaleSWCircleElHandler,
    {
      passive: false,
    }
  );
  selector_w_circle_el.addEventListener(
    "touchstart",
    touchStartOnSelectorScaleWCircleElHandler,
    {
      passive: false,
    }
  );
  selector_nw_circle_el.addEventListener(
    "touchstart",
    touchStartOnSelectorScaleNWCircleElHandler,
    {
      passive: false,
    }
  );
  selector_r_circle_el.addEventListener(
    "touchstart",
    touchStartOnSelectorRotateCircleElHandler,
    {
      passive: false,
    }
  );
};
